// // import React from "react";
// import { CameraIcon } from "@heroicons/react/24/outline";
// import { MedicalStaffService } from "../../../shared/services/medicalStaffService";

// // Compress and convert image to Blob
// const compressImage = (file, maxWidth = 400, quality = 0.7) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);

//     reader.onload = (event) => {
//       const img = new Image();
//       img.src = event.target.result;

//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         let width = img.width;
//         let height = img.height;

//         if (width > height) {
//           if (width > maxWidth) {
//             height = (height * maxWidth) / width;
//             width = maxWidth;
//           }
//         } else {
//           if (height > maxWidth) {
//             width = (width * maxWidth) / height;
//             height = maxWidth;
//           }
//         }

//         canvas.width = width;
//         canvas.height = height;

//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(img, 0, 0, width, height);

//         canvas.toBlob(
//           (blob) => {
//             resolve(blob);
//           },
//           "image/jpeg",
//           quality
//         );
//       };

//       img.onerror = reject;
//     };

//     reader.onerror = reject;
//   });

// export const ProfileUpload = ({ field, value, onChange, error }) => {
//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (!file.type.startsWith("image/")) {
//       console.error("Please select an image file");
//       return;
//     }

//     if (file.size > 5 * 1024 * 1024) {
//       console.error("File size must be less than 5MB");
//       return;
//     }

//     try {
//       // 1️⃣ Compress image
//       const compressedBlob = await compressImage(file);

//       // Convert Blob → File to upload properly
//       const compressedFile = new File([compressedBlob], file.name, {
//         type: "image/jpeg",
//       });

//       // 2️⃣ Upload to server
//       const uploadRes = await MedicalStaffService.uploadProfilePhoto(compressedFile);

//       const imageUrl = uploadRes?.data?.url;

//       if (!imageUrl) {
//         console.error("Upload failed: no URL received");
//         return;
//       }

//       // 3️⃣ Store URL in form
//       onChange(field.name, imageUrl);
//     } catch (err) {
//       console.error("Error uploading image:", err);
//     }
//   };

//   return (
//     <div className="space-y-3">
//       <label className="block text-sm font-medium text-gray-700 text-center">{field.label}</label>

//       <div className="flex flex-col items-center space-y-4">
//         {/* Upload preview */}
//         <div className="relative rounded-full cursor-pointer group overflow-hidden" onClick={() => document.getElementById(field.name).click()} style={{ width: "120px", height: "120px" }}>
//           {value ? (
//             <img src={value} alt="Profile preview" className="w-full h-full object-cover rounded-full" />
//           ) : (
//             <div className="w-full h-full bg-gray-100 flex items-center justify-center rounded-full">
//               <CameraIcon className="h-12 w-12 text-gray-400" />
//             </div>
//           )}

//           {/* hover overlay */}
//           <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center">
//             <CameraIcon className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
//           </div>
//         </div>

//         {/* Remove image */}
//         {value && (
//           <button
//             type="button"
//             onClick={(e) => {
//               e.stopPropagation();
//               onChange(field.name, null);
//             }}
//             className="text-sm text-red-600 hover:text-red-800"
//           >
//             Remove photo
//           </button>
//         )}
//       </div>

//       <input id={field.name} type="file" accept={field.accept || "image/*"} onChange={handleFileChange} className="hidden" />

//       {error && <p className="text-sm text-red-600 text-center">{error}</p>}
//     </div>
//   );
// };
import React from "react";
import { CameraIcon } from "@heroicons/react/24/outline";
import { MedicalStaffService } from "../../../shared/services/medicalStaffService";

// Compress and convert image to Blob
const compressImage = (file, maxWidth = 400, quality = 0.7) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxWidth) {
            width = (width * maxWidth) / height;
            height = maxWidth;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          "image/jpeg",
          quality
        );
      };

      img.onerror = reject;
    };

    reader.onerror = reject;
  });

export const ProfileUpload = ({ field, value, onChange, error }) => {
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      console.error("Please select an image file");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      console.error("File size must be less than 5MB");
      return;
    }

    try {
      // 1️⃣ Compress image
      const compressedBlob = await compressImage(file);

      // Convert Blob → File to upload properly
      const compressedFile = new File([compressedBlob], file.name, {
        type: "image/jpeg",
      });

      // 2️⃣ Upload to server
      const uploadApi = field.uploadApi || MedicalStaffService.uploadProfilePhoto;
      const uploadRes = await uploadApi(compressedFile);

      let imageUrl = uploadRes?.data?.imageUrl || uploadRes?.data?.url || uploadRes?.url;

      if (!imageUrl) {
        console.error("Upload failed: no URL received", uploadRes);
        return;
      }

      // Convert http to https only for non-localhost URLs (localhost has no SSL)
      if (imageUrl.startsWith("http://") && !imageUrl.includes("localhost")) {
        imageUrl = imageUrl.replace("http://", "https://");
      }

      // 3️⃣ Store URL in form
      onChange(field.name, imageUrl);
    } catch (err) {
      console.error("Error uploading image:", err);
    }
  };
  const displayUrl = value?.startsWith("https://localhost") ? value.replace("https://localhost", "http://localhost") : value;

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-[#232526] text-center">{field.label}</label>

      <div className="flex flex-col items-center space-y-4">
        {/* Upload preview */}
        <div className="relative rounded-full cursor-pointer group overflow-hidden" onClick={() => document.getElementById(field.name).click()} style={{ width: "120px", height: "120px" }}>
          {displayUrl ? (
            <img src={displayUrl} alt="Profile preview" className="w-full h-full object-cover rounded-full" />
          ) : (
            <div className="w-full h-full bg-gray-100 flex items-center justify-center rounded-full">
              <CameraIcon className="h-12 w-12 text-gray-400" />
            </div>
          )}

          {/* hover overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center">
            <CameraIcon className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
          </div>
        </div>

        {/* Remove image */}
        {value && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onChange(field.name, null);
            }}
            className="text-sm text-red-600 hover:text-red-800"
          >
            Remove photo
          </button>
        )}
      </div>

      <input id={field.name} type="file" accept={field.accept || "image/*"} onChange={handleFileChange} className="hidden" />

      {error && <p className="text-sm text-red-600 text-center">{error}</p>}
    </div>
  );
};
